export const LocalStorage = {
    EZTURN_TENANT_TOKEN: 'EZTURN_TENANT_TOKEN',
    MOVE_IN_SURVEY_SUBMITTED: 'MOVE_IN_SURVEY_SUBMITTED',
    PENDING_INVITE_TOKEN: 'EZTURN_PENDING_INVITE_TOKEN',
}

export const isMoveInSurveySubmitted = (leaseId: number): boolean => {
    const raw = localStorage.getItem(LocalStorage.MOVE_IN_SURVEY_SUBMITTED)
    if (!raw) return false
    const ids: number[] = JSON.parse(raw)
    return ids.includes(leaseId)
}

export const markMoveInSurveySubmitted = (leaseId: number): void => {
    const raw = localStorage.getItem(LocalStorage.MOVE_IN_SURVEY_SUBMITTED)
    const ids: number[] = raw ? JSON.parse(raw) : []
    if (!ids.includes(leaseId)) {
        ids.push(leaseId)
        localStorage.setItem(
            LocalStorage.MOVE_IN_SURVEY_SUBMITTED,
            JSON.stringify(ids),
        )
    }
}

export function capturePendingInviteToken(search?: string): string | null {
    const query = new URLSearchParams(search ?? window.location.search)
    const fromUrl = query.get('invite')
    if (fromUrl) {
        localStorage.setItem(LocalStorage.PENDING_INVITE_TOKEN, fromUrl)
        return fromUrl
    }
    return localStorage.getItem(LocalStorage.PENDING_INVITE_TOKEN)
}

export function clearPendingInviteToken(): void {
    localStorage.removeItem(LocalStorage.PENDING_INVITE_TOKEN)
}
